import React, { Component } from "react";

import "./Welcome.scss"

class Welcome extends Component {
  constructor() {
    super()
    this.state = {
    }
  }
  render() {
    return (
      <section className="section section-welcome">
        <div className="padding">
          <div className="container">
            <div className="row-mobile">
              <div className="logozapa"></div>
              <a target="_blank" href="https://ynet.co.il"><div className="ynetLogo"></div></a>
            </div>
            <div className="logoproject"></div>
            <div className="headline">
              <div className="head">
                אתם קובעים מהו דואט האהבה הישראלי הטוב ביותר ויכולים לזכות בשנה של הופעות חיות במתנה </div>
              <div className="desc">
                ט"ו באב הוא חגיגה מוזיקלית של אהבה, והדרך המרגשת ביותר לחגוג היא בהופעה טובה.<br/> רגע לפני החג,
                <span className="red"> ynet</span> בשיתוף <span className="gold">קבוצת זאפה</span>&nbsp;
                מזמינים אתכם לבחור מתוך 60 דואטים של שירי אהבה ישראליים את הדואט הכי מדהים

              </div>
            </div>
            <div className="separator"></div>
            <div className="teaser">
              מתאים לכם גם לקבל שנה של הפועות חיות במתנה? לאחר הבחירה מלאו את פרטיכם וענו על החידון.<br />
              <span className="gold">
                העונה נכונה על כל השאלות במהירות הגבוהה ביותר תזכה/יזכה בכפוף לתקנון בשנה של הופעות במועדוני זאפה. כיף לא? בואו נתחיל
            </span>
            </div>
            <div className="separator"></div>
          </div>
        </div>
      </section>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx